module.exports = __webpack_public_path__ + "img/475.543dbb55.png";